import styled from '@emotion/styled';

import theme from '../../../../../styles/theme';
import { rem } from '../../../../../styles/theme/layout';

export const AddressContainer = styled.address`
  font-style: normal;

  & > span {
    display: block;
    margin-bottom: ${rem(4)};
  }
`;

export const ItemsSimplified = styled.dl`
  & > dt,
  & > dd {
    display: block;
    padding: 0;
    margin: 0;
  }

  & > dt {
    margin: ${rem(20)} 0 ${rem(6)};
    font-weight: bold;
  }

  & > dd {
    padding-bottom: ${rem(20)};
    border-bottom: 1px solid ${theme.colors.lightGray};
  }
`;
